// eslint-disable-next-line import/prefer-default-export
export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
